import { Checkbox, Container } from "@mui/material";
import BasicButton from "components/BasicInputs/BasicButton";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import PageHeader from "components/Shared/PageHeader";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { apiGetPermissions, apiSaveRole, apiUpdateRole } from "api/roleApi";
import BasicSelect from "components/BasicInputs/BasicSelect";

export interface RoleProps {
}

export default function Role(props: RoleProps) {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { id } = useParams();
  const store = useSelector((state: any) => state);
  const token = store.businessReducer.business.token;
  const roles: Role[] = store.roleReducer.roles;
  const permissions: Permission[] = store.permissionReducer.permissions || [];
  const [state, setState] = useState<{
    fa_title: string | number;
    permissionIds: number[];
  }>({
    fa_title: "",
    permissionIds: []
  });
  const role = roles.find((x) => `${x.id}` === id);
  const isEdit = !!role;


  useEffect(() => {
    if (role) {
      setState({ fa_title: role.fa_title, permissionIds: role.Accesses.map((x: any) => x.id) });
    }
  }, [role]);

  useEffect(() => {
    // if (!permissions || permissions.length === 0) {
    apiGetPermissions(token, null, dispatch);
    // }
  }, [token]);

  function handleSubmit() {
    if (isEdit) {
      dispatch(
        apiUpdateRole(token, id, state, (res: any) => {
          navigate("/settings/userManagement/roles");
        })
      );
    } else {
      dispatch(
        apiSaveRole(token, state, (res: any) => {
          navigate("/settings/userManagement/roles");
        })
      );
    }
  }

  return (
    <Container maxWidth="lg" className="flex flex-col gap-6">
      <PageHeader heading="افزودن نقش جدید" subHeading="تنظیمات اطلاعات و دسترسی های کاربر" />
        <div className="bg-white rounded-md">
          <div className="p-4 border-b border-gray-300">
            <span>مشخصات</span>
          </div>
          <div className="p-4 flex items-center justify-between">
            <BasicTextInput
              val={state?.fa_title || ""}
              label="عنوان نقش"
              style={{ width: 300 }}
              required={true}
              onChange={(val) => setState((x) => ({ ...x, fa_title: val }))}
            />
            <BasicSelect
              options={roles}
              label="دسترسی های پیشفرض"
              containerStyle={{ minWidth: 300 }}
              onChange={(val, option) => {
                setState({ fa_title: option.fa_title, permissionIds: option.Accesses.map((x: any) => x.id) });
              }}
            />
          </div>
        </div>
        <div className="bg-white rounded-md">
          <div className="p-4 border-b border-gray-300">
            <span>دسترسی ها</span>
          </div>
          <div className="flex flex-col gap-6 p-6">
            {Array.isArray(permissions) &&
              permissions?.map((section, i) => {
                const cols = section.rows;
                const rows = section.columns;
                return (
                  <table key={i} className="w-full rounded-md">
                    <tr>
                      <td className="bg-[#F2F5FC] text-[#6B7888] h-14 text-center">-</td>
                      {cols.map((col, i) => {
                        return <td key={i}
                                   className="bg-[#F2F5FC] text-[#6B7888] h-14 text-center">{col}</td>;
                      })}
                    </tr>
                    {rows.map((row, i) => {
                      const allowedPermissions: any[] = row.permission_data;
                      return (
                        <tr key={i}>
                          <td className="bg-[#F2F5FC] text-[#6B7888] w-44 h-14 text-center border-b border-[#F2F5FC]">
                            {row?.title}
                          </td>
                          {cols.map((col, i) => {
                            let p = state?.permissionIds;
                            const permission = allowedPermissions.find((x) => x.fa_title === col);
                            return (
                              <td key={i} className="text-center border-b border-gray-300">
                                <Checkbox
                                  key={`${state.permissionIds.includes(permission?.id)}`}
                                  checked={state.permissionIds.includes(permission?.id)}
                                  disabled={!allowedPermissions.map((x) => x.fa_title).includes(col)}
                                  onChange={(_, checked) => {
                                    if (p && permission) {
                                      if (checked) p.push(permission.id);
                                      else p = p.filter((x) => x !== permission.id);
                                      setState((x) => ({ ...x, permissionIds: p }));
                                    }
                                  }}
                                />
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </table>
                );
              })}
          </div>
        </div>
        <div
          className="bg-white p-4 rounded-md sticky bottom-0 left-0 flex items-center flex-row-reverse gap-4 shadow-[0_0_10px_0px_rgba(0,0,0,0.2)]">
          <BasicButton variant="contained" className="w-44" onClick={() => handleSubmit()}>
            <span>{isEdit ? "ذخیر نقش" : "ذخیر نقش جدید"}</span>
          </BasicButton>
          <BasicButton variant="outlined" className="w-28" onClick={() => navigate(-1)}>
            <span>لغو</span>
          </BasicButton>
        </div>
    </Container>

  );
}
